import { useEffect, useState } from "react";

const useFullscreenElement = () => {
    const [fullscreenElement, setFullscreenElement] = useState(null);

    useEffect(() => {
        const handleFullscreenChange = () => {
            if (document.fullscreenElement) {
                setFullscreenElement(document.fullscreenElement);
            } else {
                setFullscreenElement(null);
            }
        };
        document.addEventListener("fullscreenchange", handleFullscreenChange);

        return () => {
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
        };
    }, []);

    return fullscreenElement;
};

export default useFullscreenElement;
